<template>

  <div class="cliente-list-item">

    <div class="cliente-list-item__icon">

      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">

        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>

      </svg>

    </div>

    <div class="cliente-list-item__body min-w-0 flex-1">

      <div class="flex items-center gap-2 flex-wrap">

        <span class="cliente-list-item__badge">{{ tipoLabel }}</span>

        <span v-if="endereco.principal" class="cliente-list-item__badge cliente-list-item__badge--principal">{{ t('workspaceClienteModal.endereco.principal') }}</span>

      </div>

      <p class="cliente-list-item__title">{{ endereco.logradouro }}, {{ endereco.numero }}</p>

      <p class="cliente-list-item__sub">

        <template v-if="endereco.bairro">{{ endereco.bairro }} · </template>

        {{ endereco.cidade }} — {{ endereco.estado }}

        <template v-if="endereco.cep"> · CEP {{ formatCep(endereco.cep) }}</template>

      </p>

    </div>

    <div class="cliente-list-item__actions">

      <ClienteIconBtn variant="edit" @click="$emit('edit')" />

      <ClienteIconBtn variant="delete" @click="$emit('remove')" />

    </div>

  </div>

</template>



<script setup>

import { computed } from 'vue'

import { useI18n } from 'vue-i18n'

import { maskCep } from '@/composables/useCepLookup'

import ClienteIconBtn from './ClienteIconBtn.vue'



const props = defineProps({

  endereco: { type: Object, required: true }

})



defineEmits(['edit', 'remove'])



const { t } = useI18n()



const formatCep = (cep) => maskCep(cep)



const tipoLabel = computed(() => {

  const map = {

    RESIDENCIAL: t('workspaceClienteModal.endereco.tipoResidencial'),

    COMERCIAL: t('workspaceClienteModal.endereco.tipoComercial'),

    OUTRO: t('workspaceClienteModal.endereco.tipoOutro')

  }

  return map[props.endereco.tipo] || props.endereco.tipo

})

</script>



<style scoped>

.cliente-list-item {

  display: flex;

  align-items: flex-start;

  gap: 0.75rem;

  padding: 0.875rem 1rem;

  border-radius: 4px;

  margin-bottom: 0.5rem;

  transition: box-shadow 0.15s;

}

.cliente-list-item:hover {

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

}

.cliente-list-item__icon {

  width: 2.5rem;

  height: 2.5rem;

  border-radius: 4px;

  background: linear-gradient(135deg, #10b981, #0d9488);

  color: #fff;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

}

.cliente-list-item__icon svg {

  width: 1.25rem;

  height: 1.25rem;

}

.cliente-list-item__actions {

  display: flex;

  align-items: center;

  gap: 0.375rem;

  flex-shrink: 0;

}

</style>

